export interface Some<T> {
	value: T;
}

export interface None {
	value: null;
}

export type Option<T> = Some<T> | None;

export function some<T>(value: T): Some<T> {
	return { value };
}

export function none(): None {
	return { value: null };
}

export function isSome<T>(option: Option<T>): option is Some<T> {
	return option.value !== null;
}

export function isNone<T>(option: Option<T>): option is None {
	return option.value === null;
}
